import AuthenticationContext from "@Contexts/Authentication.context";
import { useContext } from "react";

const useAuthentication = () => {
  const context = useContext(AuthenticationContext);

  return context;
};

export default useAuthentication;
